export interface MListProps {
  /** Tighter row height + padding (ports Quasar q-list `dense`). */
  dense?: boolean;
  /** Divider line between rows (ports Quasar q-list `separator`). */
  separator?: boolean;
  /** Border around the whole list (ports Quasar q-list `bordered`). */
  bordered?: boolean;
}

export const mListDefaults = {
  dense: false,
  separator: false,
  bordered: false,
} satisfies Partial<MListProps>;
